import { lazy } from "react";

const ContentLoader = lazy(() => import("react-content-loader"));

interface ISliderSkeleton {
  count: number;
}

const SliderSkeleton = ({ count }: ISliderSkeleton) => {
  return (
    <div className="mt-[54px] ">
      <ContentLoader
        speed={2}
        width={195}
        height={26}
        viewBox="0 0 195 26"
        backgroundColor="#e1e1e1"
        foregroundColor="#fff"
        key="skeleton-title"
      >
        <rect x="0" y="0" rx="16" ry="16" width="195" height="26" />
      </ContentLoader>
      <div className="max-md:flex max-md:gap-4 grid grid-cols-6 mt-4">
        {Array.from({ length: count }, (_, index) => (
          <div key={`skeleton_${index}`}>
            <div className="gap-4 mt-4">
              <ContentLoader
                speed={2}
                width={200}
                height={228}
                viewBox="0 0 200 228"
                backgroundColor="#C2C2C2"
                foregroundColor="#fff"
                key="skeleton-card_1"
              >
                <rect x="0" y="0" rx="10" ry="10" width="200" height="200" />
                <rect x="57" y="208" rx="14" ry="14" width="85" height="20" />
              </ContentLoader>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

SliderSkeleton.displayName = "SliderSkeleton";
export default SliderSkeleton;
